import Vue from 'vue'
// import { Role } from '../role/role.js';
import Router from 'vue-router'
import TermsOfService from '../views/gdpr/TermsOfService.vue'
import PrivacyPolicy from '../views/gdpr/PrivacyPolicy.vue'
import Registration from '../views/authentication/Registration.vue'
import Profile from '../views/account/Profile.vue'
import Login from '../views/authentication/Login.vue'
import Verification from '../views/authentication/Verification.vue'
import ResetPassword from '../views/authentication/ResetPassword.vue'
//import CreateSpace from '../views/spaces/CreateSpace.vue'
import MySpaces from '../views/spaces/MySpaces.vue'
import PageNotFound from '../views/global/PageNotFound'
import PageAccessDenied from '../views/global/PageAccessDenied'
import ConfirmationDeleteAccount from '../views/account/ConfirmationDeleteAccount.vue'
import PageMaintenanceMode from '../views/global/PageMaintenanceMode.vue'
import RegistrationGettingStarted from '../views/authentication/RegistrationGettingStarted.vue'
import AcceptGDPR from '../views/authentication/AcceptGDPR.vue'
import FortnoxCallback from '../views/spaces/FortnoxCallback.vue'
import VismaCallback from '../views/spaces/VismaCallback.vue'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            component: MySpaces,
            meta: { showTopNavigation: true, requiresAuth: true }
        },
        {
            path: '/callback',
            name: 'FortnoxCallback',
            component: FortnoxCallback,
        },
        {
            path: '/visma-callback',
            name: 'VismaCallback',
            component: VismaCallback,
        },
        {
            path: '/terms-of-service',
            name: 'TermsOfService',
            component: TermsOfService
        },
        {
            path: '/privacy-policy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy
        },
        {
            path: '/register',
            name: 'Registration',
            component: Registration,
            meta: { hideForAuth: true }
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile,
            meta: { showTopNavigation: true, requiresAuth: true }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: { hideForAuth: true }
        },
        {
            path: '/verify',
            name: 'Verification',
            component: Verification
        },
        {
            path: '/reset-password/:token?',
            name: 'ResetPassword',
            component: ResetPassword
        },
        {
            path: '/profile/delete',
            name: 'ConfirmationDeleteAccount',
            component: ConfirmationDeleteAccount,
            meta: { requiresAuth: true }
        },
        //Hide the creating new space icon on my spaces page
        /*{
            path: '/spaces/create',
            name: 'CreateSpace ',
            component: CreateSpace,
            meta: { requiresAuth: true }
        },*/
        {
            path: '/spaces',
            name: 'MySpaces',
            component: MySpaces,
            meta: { showTopNavigation: true, requiresAuth: true }
        },
        {
            path: '/getting_started',
            name: 'RegistrationGettingStarted',
            component: RegistrationGettingStarted,
            meta: { hideForAuth: true }
        },
        {
            path: '/accept_gdpr',
            name: 'AcceptGDPR',
            component: AcceptGDPR,
            meta: { hideForAuth: true }
        },
        {
            path: '/403-forbidden',
            name: 'PageAccessDenied',
            component: PageAccessDenied
        },
        {
            path: '/:catchAll(.*)*',
            name: 'PageNotFound',
            component: PageNotFound
        },
        {
            path: '/:catchAll(.*)*',
            name: 'PageMaintenanceMode',
            component: PageMaintenanceMode
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (window.$cookies.get("token") == null) {
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            })
        } else {
            next();
        }
    } else if (to.matched.some(record => record.meta.hideForAuth)) {
        if (window.$cookies.get("token") != null) {
            next({
                path: '/spaces',
            })
        } else {
            next();
        }
    } else {
        next();
    }
})

export default router;